import {
  type OnboardingStatus,
  onboardingStatusSchema,
} from "@/features/home/onboarding/schemas/onboarding-status.schema";
import { apiCall } from "@/shared/lib/api-call";
import { apiPaths } from "@/shared/lib/api-paths";

export async function getOnboardingStatus(workspaceId: string): Promise<OnboardingStatus> {
  return apiCall<OnboardingStatus>(
    apiPaths.onboarding.status(workspaceId),
    { method: "GET" },
    onboardingStatusSchema,
  );
}
